// UraniumSeg23 — Parts 2-3 universal lower-left tags. Pure DATA: the Tag component itself
// lives in overlayKit, palette is mounted via context. Switching the production's motif is a
// one-line palette swap; no component code changes.
import React from "react";
import { AbsoluteFill } from "remotion";
import { PaletteProvider, Tag } from "./overlayKit";
import { URANIUM_PALETTE } from "./UraniumPalette";

export const UraniumSeg23: React.FC = () => (
  <PaletteProvider value={URANIUM_PALETTE}>
    <AbsoluteFill>
      {/* Part 2 — pellets → rods → reactor */}
      <Tag inS={15.05} outS={17.75} value={300} valueS={15.302} endS={15.836}
           label="PELLETS" sub="PER FUEL ROD" color="primary" />
      <Tag inS={17.90} outS={21.10}
           label="THOUSANDS OF RODS" sub="PER REACTOR" color="primary" />
      {/* 20200 "powers entire cities" — deliberately no overlay (payoff shot) */}

      {/* Part 3 — the twist: raw is useless */}
      <Tag inS={25.40} outS={29.70}
           label="RAW URANIUM ORE" sub="STRAIGHT FROM THE GROUND" color="secondary" />
      <Tag inS={31.85} outS={34.55} value={99.3} decimals={1} suffix="%" valueS={32.078} endS={33.274}
           label="USELESS" sub="IN ITS NATURAL STATE" color="secondary" />
      <Tag inS={34.80} outS={39.90} value={0.7} decimals={1} suffix="%" valueS={34.980} endS={35.851}
           label="FISSILE · U-235" sub="ACTUALLY SPLITS" color="primary" />
    </AbsoluteFill>
  </PaletteProvider>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
